import React, { useState, useMemo } from 'react';
import { useQuery } from 'react-query';
import { Chip, Dialog, DialogTitle, DialogContent, DialogActions, Button, CircularProgress } from '@material-ui/core';
import { fetchTopEarners } from '../services';
import TableContainerServerSide from './TableContainerServerSide';

const TopEarnersModal = ({ isOpen, onClose }) => {
    const [selectedCurrency, setSelectedCurrency] = useState(null);

    const currencies = [
        { id: 1, name: 'USD', label: 'USD' },
        { id: 2, name: 'EGP', label: 'EGP' },
        { id: 3, name: 'SAR', label: 'SAR' },
        { id: 4, name: 'AED', label: 'AED' }
    ];

    const { data: topEarners = [], isLoading, refetch } = useQuery(
        ['top-earners', selectedCurrency],
        () => fetchTopEarners(selectedCurrency),
        {
            select: data => data.topEarners,
            enabled: !!selectedCurrency,
            refetchOnWindowFocus: false,
        }
    );

    const columns = useMemo(() => [
        {
            Header: 'Name',
            accessor: 'name',
            Filter: null,
            disableFilters: true
        },
        {
            Header: 'Email',
            accessor: 'email',
            Filter: null,
            disableFilters: true
        },
        {
            Header: 'Total Earnings',
            accessor: 'total_amount',
            Filter: null,
            disableFilters: true,
            Cell: ({ cell }) => {
                return cell.value ? `${selectedCurrency === 1 ? '$' : selectedCurrency === 2 ? 'EGP' : selectedCurrency === 3 ? 'SAR' : 'AED'}${cell.value}` : 'N/A';
            }
        },
    ], [selectedCurrency]);

    const handleCurrencySelect = (currency) => {
        setSelectedCurrency(currency.id);
    };

    const handleClose = () => {
        setSelectedCurrency(null);
        onClose();
    };

    const handleRefetchData = ({ pageIndex, pageSize, search, export: exportColumns }) => {
        return Promise.resolve({ data: topEarners, total: topEarners.length });
    };

    return (
        <Dialog
            open={isOpen}
            onClose={handleClose}
            maxWidth="lg"
            fullWidth
        >
            <DialogTitle>
                <div className="is-flex aic jcsb">
                    <h3 className="mt-0 mb-0">Top Earners</h3>
                    <Button onClick={handleClose} color="secondary">
                        Close
                    </Button>
                </div>
            </DialogTitle>

            <DialogContent>
                <div className="mb-20">
                    <h4 className="mb-10">Select Currency:</h4>
                    <div className="is-flex aic" style={{ gap: '10px' }}>
                        {currencies.map((currency) => (
                            <Chip
                                key={currency.id}
                                label={currency.label}
                                onClick={() => handleCurrencySelect(currency)}
                                className={selectedCurrency === currency.id ? 'chip-blue' : 'chip-grey'}
                                clickable
                            />
                        ))}
                    </div>
                </div>

                {selectedCurrency ? (
                    <div>
                        <h4 className="mb-10">
                            Top Earners - {currencies.find(c => c.id === selectedCurrency)?.label}
                        </h4>

                        {isLoading ? (
                            <div className="is-flex aic jcc" style={{ padding: '40px' }}>
                                <CircularProgress />
                            </div>
                        ) : (
                            <TableContainerServerSide
                                name={`top-earners-${selectedCurrency}`}
                                paging={false}
                                columns={columns}
                                hiddenColumns={[]}
                                data={topEarners}
                                hasFilters={false}
                                allowSorting={false}
                                loading={isLoading}
                                pageCount={1}
                                fetchData={handleRefetchData}
                                dataFetcher={(params) => {
                                    if (params.export) {
                                        return Promise.resolve(topEarners);
                                    }
                                    return Promise.resolve({ data: topEarners, total: topEarners.length });
                                }}
                                withExport={true}
                            />
                        )}
                    </div>
                ) : (
                    <div className="is-flex aic jcc" style={{ padding: '40px' }}>
                        <p>Please select a currency to view the top earners</p>
                    </div>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default TopEarnersModal;
